// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'pen-solid';

export const Component = () => (
  <path d='M16.171 4.39 17.561 3l3.495 3.448L7.36 20.146l-1.725-.335-1.245 1.198-1.054-.336L3 19.62l1.245-1.198-.383-1.724 11.64-11.639-.67-.67-6.945 6.945-.719-.72L14.782 3l1.39 1.39Zm-.67.67 3.448 3.495.719-.718-3.496-3.449-.67.67-.001.001Z' />
);

export const viewBox = '0 0 25 25';
